<template>
    <view class="tabsBox" v-if="data.length">
        <cusButton @click="onChange({ index, item })" v-for="(item, index) in data" :key="index" class="tabsItem" :style="styles" :class="{ activeTab: active === index }">
            <view>{{ item.name }}</view>
        </cusButton>
    </view>
</template>

<script setup>
    import { ref } from 'vue';
    const active = ref(0);
    defineProps({
        data: {
            type: Array,
            default: () => []
        },
        styles: {
            type: [Object, String],
            default: () => ({})
        }
    });
    const $emits = defineEmits(['change']);
    const onChange = (e) => {
        if (active.value !== e.index) {
            active.value = e.index;
            $emits('change', e);
        }
    };
    defineExpose({
        onChange,
        active
    });
</script>

<style lang="scss" scoped>
    .tabsBox {
        padding: 0px 24px 0px;
        box-sizing: border-box;
        width: calc(100% - 32px);
        display: flex;
        align-items: flex-end;
        height: 100%;
        .tabsItem {
            height: 75%;
            font-size: 24px;
            color: #828282;
            font-weight: 500;
            display: inline-block;
            white-space: nowrap;
            position: relative;
            margin-right: 30px;
            &.activeTab {
                color: #000000;
                font-weight: 600;
                transition: all 0.2s;
                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width: 100%;
                    margin: 0 auto;
                    height: 4px;
                    border-radius: 5px;
                    background-color: #cf9b28;
                }
            }
        }
    }
</style>
